import { StyledGridColumn, StyledGridContainer } from '@components/Grid/Grid.style';
import { DisplayH2 } from '@components/Text/HeadingTagDisplay.style';
import { Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import { DivAllCenter } from '@pages/CommonStyle/commonDiv.style';
import { StyledFaq, StyledFaqGridRow } from '@pages/Main/Common/Faq/Faq.style';
import FaqItem from '@pages/Main/Common/Faq/Item';
import home from '@src/lang/ko/main/home/home';
import React, { useState } from 'react';
import { Trans } from 'react-i18next';

const Faq = ({}) => {
  const [isOpenIndex, setIsOpenIndex] = useState<number>(-1);
  const handleClickItem = (index: number) => {
    setIsOpenIndex(isOpenIndex === index ? -1 : index);
  };

  return (
    <>
      <SpacingDTM d="128" t="128" m="96" />

      <StyledFaq>
        <StyledGridContainer>
          <DivAllCenter>
            <DisplayH2 size="small">
              <Trans i18nKey={`home.faq.title`} />
            </DisplayH2>
          </DivAllCenter>

          <StyledFaqGridRow>
            <StyledGridColumn desktop={12} tablet={8} mobile={4}>
              {home.faq.list.map((item, i) => {
                return (
                  <FaqItem
                    key={`faq-item-${i}`}
                    title={`home.faq.list.${i}.q`}
                    description={`home.faq.list.${i}.a`}
                    isOpen={isOpenIndex === i}
                    isTail={false}
                    handleClick={() => {
                      handleClickItem(i);
                    }}
                  />
                );
              })}
            </StyledGridColumn>
          </StyledFaqGridRow>

          <SpacingDTM d="128" t="128" m="96" />
        </StyledGridContainer>
      </StyledFaq>
    </>
  );
};

export default Faq;
